module.exports = __webpack_public_path__ + "static/img/bcg3.c5293c5f.png";